import { Agent } from '../graphql/components';

/**
 * Returns a type-safe name of the given type or interface.
 */
export const nameOf = <T>(name: keyof T) => name;

/**
 * helper for formatting person's name when there is no full Agent object available, only its name fields
 */
export const formatNameOfPerson = (firstName: string, lastName: string) => `${firstName} ${lastName}`;

/**
 * return full name of agent in format: firstName{' '}lastName
 * eq. "John Doe"
 */
export const fullNameOfAgent = ({ name, surname }: Agent) => formatNameOfPerson(name, surname);

/**
 * helper returning name fractions in exactly same order as other name formatters
 * @param firstName person's first name
 * @param lastName person's last name (surname)
 * @returns array with ordered first name and last name
 */
export const fullNameOfAgentInOrder = (firstName: string, lastName: string) => [firstName, lastName];

/**
 * helper for deciding if search field should be rendered
 * @param items array of items based on which helper fn will decide whether to display search field
 * @returns true in case of count of element is 15 or more
 */
export const shouldShowSearchField = (itemsLength: number) => itemsLength > 14;
